import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 8.70127 13.8797 9.37444 13.6586 10H9.33333C8.59695 10 8 10.597 8 11.3333V14ZM8 4.66667C8.36819 4.66667 8.66667 4.96514 8.66667 5.33333V7.66667H10.6667C11.0349 7.66667 11.3333 7.96514 11.3333 8.33333C11.3333 8.70152 11.0349 9 10.6667 9H8C7.63181 9 7.33333 8.70152 7.33333 8.33333V5.33333C7.33333 4.96514 7.63181 4.66667 8 4.66667Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M10.6667 10.3333C11.0349 10.3333 11.3333 10.6318 11.3333 11V12C11.3333 12.3682 11.0349 12.6667 10.6667 12.6667C10.2985 12.6667 10 12.3682 10 12V11C10 10.6318 10.2985 10.3333 10.6667 10.3333Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M10.6667 14.6667C11.0349 14.6667 11.3333 14.3682 11.3333 14C11.3333 13.6318 11.0349 13.3333 10.6667 13.3333C10.2985 13.3333 10 13.6318 10 14C10 14.3682 10.2985 14.6667 10.6667 14.6667Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}